import ProfileEnum from 'containers/pages/profile/ts/profileEnum';

export const initProfileUser = {
	id: '',
	contactId: '',
	firstName: '',
	lastName: '',
	phoneWork: '',
	phoneWorkDialCode: '',
	phoneWorkCountryCode: '',
	phoneWorkExt: '',
	phoneMobile: '',
	phoneMobileDialCode: '',
	phoneMobileCountryCode: '',
	phoneMobileExt: '',
	phoneOther: '',
	phoneOtherDialCode: '',
	phoneOtherCountryCode: '',
	phoneOtherExt: '',
	emailWork: '',
	emailPersonal: '',
	emailOther: '',
	note: '',
	vFileId: '',
	username: '',
	isEnabled: false,
	masterCustId: '',
	roles: [],
	contactTypes: [],
	companies: [],
	addressIds: [],
	languageIds: [],
	addresses: [],
};

export const initValid = {
	[ProfileEnum.PASSWORD]: { hasErr: false, msg: '', canNotSave: true },
	[ProfileEnum.CONFIRM_PASSWORD]: { hasErr: false, msg: '', canNotSave: true },
};

export const initPwd = {
	[ProfileEnum.PASSWORD]: '',
	[ProfileEnum.CONFIRM_PASSWORD]: '',
};
